import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import { DragDropContextProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import TouchBackend from 'react-dnd-touch-backend'
import { isMobile } from 'react-device-detect';
import ScrollToTop from './routes/ScrollToTop'

import Routes from './routes';
import './App.css';
import './components/demographics/styles/demographics-style.css';
import './components/screens/styles/screen-style.css';
import './components/assessment/styles/assessment-style.css';
import './components/assessment/styles/task-style.css';
import './components/common/styles/common-style.css';
import { LastLocationProvider } from 'react-router-last-location';

const App = ({history}) => (
  <DragDropContextProvider backend={isMobile ? TouchBackend : HTML5Backend }>
      <ConnectedRouter history={history}>
        <ScrollToTop/>
        {Routes}   
      </ConnectedRouter>
  </DragDropContextProvider>
 );

 App.propTypes = {
  history: PropTypes.object
}

export default App;